import axios from "axios";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { IInPhieuParams } from "../../models/params";
import { APP_CONFIGURATION_KEYS } from "../../utils/Constant";
import { localStorageItem } from "../../utils/LocalStorage";
import { urlParamsConfig } from "../../utils/ParamsUtils";
import { SearchObject } from "../models/KhamDoanModel";

type IParamsInPhieu = {
    exportId: string,
    parameters: {
        name: string,
        value: string
    }[],
};

const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] || process.env.REACT_APP_API_URL;
const REPORT_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.REPORT_URL] || process.env.REACT_APP_REPORT_API_URL;
const API_PATH_DS_HOP_DONG = API_PATH + '/contracts'
const API_PATH_CATEGORY = (localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.ADMIN_URL] || process.env.REACT_APP_ADMIN_API_URL) + "/simple-categories";
const API_PATH_DS_NHAN_VIEN = API_PATH + '/pestaff'
const API_PATH_DS_GOI_KHAM_DICH_VU = API_PATH + '/exam-package'
const API_PATH_DS_ORDER_GROUP = API_PATH + '/peorders/order-groups'
const API_PATH_DETAIL_ORDER_GROUP = API_PATH + '/peorders/terms'
const API_PATH_DS_ORDER_KHAM_BENH = API_PATH + '/peorders/orders'
const API_PATH_START_KHAM_BENH = API_PATH + '/pestaff/arrive-exam'
const API_PATH_DS_NHAN_VIEN_KLS = API_PATH + '/pe'
const API_PATH_FORM_GENERATE = API_PATH + '/pe-obs'
const API_REPORT = REPORT_URL + '/rest/reports/run'

export const searchByPage = (searchObject: SearchObject) => {
  let url = API_PATH_DS_HOP_DONG;
  return axios.get(urlParamsConfig(url, searchObject));
};
export const addHopDong = (data: any) => {
  return axios.post(API_PATH_DS_HOP_DONG, data);
};
export const updateHopDong = (data: any) => {
  let url = API_PATH_DS_HOP_DONG;
  return axios.put(url, data);
};
export const getByIdHopDong = (id: string) => {
  let url = API_PATH_DS_HOP_DONG + `/${id}`;
  return axios.get(url);
}
export const deleteHopDong = (id: string) => {
  let url = `${API_PATH_DS_HOP_DONG}/${id}`;
  return axios.delete(url);
};
export const getDanhSachHinhThucService = (searchObject: any) => {
  let url = API_PATH_CATEGORY + `/search`;
  return axios.get(urlParamsConfig(url, searchObject));
}

export const getListDsNhanVien = (searchObject: any) => {
  let url = API_PATH_DS_NHAN_VIEN + `/search`;
  return axios.get(urlParamsConfig(url, searchObject));
};
export const getListDsNhanVienKLS = (searchObject: any) => {
  let url = API_PATH_DS_NHAN_VIEN_KLS + `/search`;
  return axios.get(urlParamsConfig(url, searchObject));
};
export const getListGoiKhamDichVu = (searchObject: any) => {
  let url = API_PATH_DS_GOI_KHAM_DICH_VU + `/search`;
  return axios.get(urlParamsConfig(url, searchObject));
};
export const addGoiKham = (data: any) => {
  return axios.post(API_PATH_DS_GOI_KHAM_DICH_VU, data);
};
export const updateGoiKham = (data: any) => {
  let url = API_PATH_DS_GOI_KHAM_DICH_VU + `/${data?.id}`;
  return axios.put(url, data);
};
export const getByIdGoiKham = (id: string) => {
  let url = API_PATH_DS_GOI_KHAM_DICH_VU + `/${id}`;
  return axios.get(url);
}
export const getDanhSachCategoriService = (searchObject: any) => {
  let url = API_PATH_CATEGORY + `/search`;
  return axios.get(urlParamsConfig(url, searchObject));
}
export const updateNhanVien = (data: any) => {
  let url = API_PATH_DS_NHAN_VIEN + `/${data?.id}`;
  return axios.put(url, data);
};
export const addNhanVien = (data: any) => {
  return axios.post(API_PATH_DS_NHAN_VIEN, data);
};
export const getByIdNhanVien = (id: string) => {
  let url = API_PATH_DS_NHAN_VIEN + `/${id}`;
  return axios.get(url);
}
export const deleteNhanVien = (id: string) => {
  let url = API_PATH_DS_NHAN_VIEN + `/${id}`;
  return axios.delete(url);
}
export const getListDichVuCuaNhanVien = (employeeId: any) => {
  return axios.get(`${API_PATH}/pestaff/${employeeId}/orders`);
};
export const getDsOrderGroup = (data: any, id: string) => {
  let url = API_PATH_DS_ORDER_GROUP + `/${id}`;
  return axios.get(urlParamsConfig(url, data));
};
export const getListDichVuByOrder = (data: any, id: string) => {
  let url = API_PATH_DETAIL_ORDER_GROUP + `/${id}`;
  return axios.get(urlParamsConfig(url, data));
};
export const getListOrderKhamBenh = (data: any) => {
  let url = API_PATH_DS_ORDER_KHAM_BENH+ `/${data?.id}`;
  return axios.get(urlParamsConfig(url, data));
};
export const addStartKhamBenh = (id: any) => {
  let url = API_PATH_START_KHAM_BENH + `/${id}`;
  return axios.post(url);
};
export const saveFormGenerate = (data: any, code: string, id: string) => {
  let url = API_PATH_FORM_GENERATE + `/${code}/` + id;
  return axios.put(url, data);
};
export const getDetailFormGenerate = (id: string) => {
  let url = API_PATH_FORM_GENERATE + `/${id}`;
  return axios.get(url);
};

export const getNVClasses = (id: string) => {
  let url = API_PATH_DS_NHAN_VIEN + '/get-tree-filter' + `/${id}`;
  return axios.get(url);
};

export const importDSNhanVien = (contractId: string, file: any) => {
  let url = `${API_PATH_DS_NHAN_VIEN}/import-staffs/${contractId}`;
  let formData = new FormData();
  formData.append("file", file);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(url, formData, config);
};

export const exportDSNhanVien = (contractId: string) => {
  let url = `${API_PATH_DS_NHAN_VIEN}/export-staff/${contractId}`;
  return axios.get(url, { responseType: 'blob'});
};

export const inKetQuaTongKet = async (params: IInPhieuParams) => {
  let url = API_PATH_DS_NHAN_VIEN_KLS + "/export";
  return await axios.post<Blob>(url, params, { responseType: 'blob' });
};

export const getDsNhanVienHenKham = (searchObject: any) => {
  let url = API_PATH_DS_NHAN_VIEN + `/search-staff`;
  return axios.get(urlParamsConfig(url, searchObject));
};

export const printEmployeePackage = async (params: { staffId: string; fileType?: string }) => {
	return await axios.post<Blob>(`${API_PATH_DS_NHAN_VIEN}/export/package-items`, params, {
		responseType: 'blob',
	});
};

export const printEmployeeBarcode = async (params: {
	patientId: string;
	quantity: number;
	fileType?: string;
}) => {
	return await axios.post<Blob>(`${API_PATH}/patients/print-barcode`, params, {
		responseType: 'blob',
	});
};

export const exportContractReport = async (data: IParamsInPhieu) => {
  const { exportId, parameters } = data;
  let requestBody = {
    parameters
  };
  let url = API_REPORT + `/${exportId}`;
  return await axios.post<Blob>(url, requestBody, { responseType: 'blob' });
};